module.exports = __webpack_public_path__ + "ssygl/img/query1.b3fd9a29.svg";